import Icon from "@mui/icons-material/Receipt";
import SabilReceiptList from "./SabilReceiptList";
import SabilReceiptCreate from "./SabilReceiptCreate";
import SabilReceiptEdit from "./SabilReceiptEdit";

export default {
  list: SabilReceiptList,
  create: SabilReceiptCreate,
  edit: SabilReceiptEdit,
  icon: Icon,
  label: "Sabil Receipts",
  options: { label: "Sabil Receipts" },
  name: "sabilReceipt",
};
